import script from "./ListPage.vue?vue&type=script&setup=true&lang=js"
export * from "./ListPage.vue?vue&type=script&setup=true&lang=js"

import "./ListPage.vue?vue&type=style&index=0&id=540d74c4&lang=css"

const __exports__ = script;

export default __exports__